var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"modern-footer",attrs:{"app":"","absolute":""}},[_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"footer-text"},[_vm._v("2016 - "+_vm._s(_vm.currentYear)+" © Timetable, All Rights Reserved")])])])}
var staticRenderFns = []

export { render, staticRenderFns }